import {
    buscarPropietario,
    CanalMarketing,
    ModificacionPropietario, modificarPropietario,
    TipoDocumento
} from '../../../services/propietariosServicios';
import {FormState} from './FormState';

export const cargarPropietario = async (id: string): Promise<FormState> => {
    const propietario = await buscarPropietario(id);

    return {
        primerNombre: {value: propietario?.primerNombre || '', wasTouched: false, isValid: undefined},
        segundoNombre: {value: propietario?.segundoNombre || '', wasTouched: false, isValid: undefined},
        primerApellido: {value: propietario?.primerApellido || '', wasTouched: false, isValid: undefined},
        segundoApellido: {value: propietario?.segundoApellido || '', wasTouched: false, isValid: undefined},
        eliminarContrato: {value: false, wasTouched: false, isValid: undefined},
        contrato: {value: undefined, wasTouched: false, isValid: undefined},
        firma: {value: "", wasTouched: false, isValid: undefined},
        tipoDocumento: {value: propietario?.tipoDocumento.toString() || '', wasTouched: false, isValid: undefined},
        documento: {value: propietario?.documento || '', wasTouched: false, isValid: undefined},
        ciudadExpedicion: {value: propietario?.ciudadExpedicion || '', wasTouched: false, isValid: undefined},
        email: {value: propietario?.email || '', wasTouched: false, isValid: undefined},
        celular: {value: propietario?.celular || '', wasTouched: false, isValid: undefined},
        nombresContactoAlterno: {
            value: propietario?.nombresContactoAlterno || '',
            wasTouched: false,
            isValid: undefined
        },
        celularContactoAlterno: {
            value: propietario?.celularContactoAlterno || '',
            wasTouched: false,
            isValid: undefined
        },
        paisResidencia: {value: propietario?.paisResidencia?.id || '', wasTouched: false, isValid: undefined},
        departamentoResidencia: {
            value: propietario?.departamentoResidencia?.id || '',
            wasTouched: false,
            isValid: undefined
        },
        ciudadResidencia: {value: propietario?.ciudadResidencia?.id || '', wasTouched: false, isValid: undefined},
        direccionResidencia: {value: propietario?.direccionResidencia || '', wasTouched: false, isValid: undefined},
        sectorResidencia: {value: propietario?.sectorResidencia?.id || '', wasTouched: false, isValid: undefined},
        canalMarketing: {value: propietario?.canalMarketing || '', wasTouched: false, isValid: undefined},
        esTurista: {value: propietario?.esTurista || false, wasTouched: false, isValid: undefined},
        paisProveniencia: {value: propietario?.paisProveniencia?.id || '', wasTouched: false, isValid: undefined},
        ciudadProveniencia: {value: propietario?.ciudadProveniencia?.id || '', wasTouched: false, isValid: undefined},
        fechaNacimiento: {
            value: propietario?.fechaNacimiento || '',
            wasTouched: false,
            isValid: undefined
        }
    };
}

export const editarPropietario = async (id: string, formState: FormState) => {
    const modificacion: ModificacionPropietario = {
        primerNombre: formState.primerNombre.wasTouched ? formState.primerNombre.value : undefined,
        segundoNombre: formState.segundoNombre.wasTouched ? formState.segundoNombre.value : undefined,
        primerApellido: formState.primerApellido.wasTouched ? formState.primerApellido.value : undefined,
        segundoApellido: formState.segundoApellido.wasTouched ? formState.segundoApellido.value : undefined,
        eliminarContrato: formState.eliminarContrato.wasTouched ? formState.eliminarContrato.value : undefined,
        contrato: formState.contrato.wasTouched ? formState.contrato.value : undefined,
        firma: formState.firma.wasTouched ? formState.firma.value : undefined,
        tipoDocumento: formState.tipoDocumento.wasTouched ? formState.tipoDocumento.value as TipoDocumento : undefined,
        documento: formState.documento.wasTouched ? formState.documento.value : undefined,
        ciudadExpedicion: formState.ciudadExpedicion.wasTouched ? formState.ciudadExpedicion.value : undefined,
        email: formState.email.wasTouched ? formState.email.value : undefined,
        celular: formState.celular.wasTouched ? formState.celular.value : undefined,
        nombresContactoAlterno: formState.nombresContactoAlterno.wasTouched ? formState.nombresContactoAlterno.value : undefined,
        celularContactoAlterno: formState.celularContactoAlterno.wasTouched ? formState.celularContactoAlterno.value : undefined,
        idPaisResidencia: formState.paisResidencia.wasTouched ? formState.paisResidencia.value : undefined,
        idDepartamentoResidencia: formState.departamentoResidencia.wasTouched ? formState.departamentoResidencia.value : undefined,
        idCiudadResidencia: formState.ciudadResidencia.wasTouched ? formState.ciudadResidencia.value : undefined,
        direccionResidencia: formState.direccionResidencia.wasTouched ? formState.direccionResidencia.value : undefined,
        idSectorResidencia: formState.sectorResidencia.wasTouched ? formState.sectorResidencia.value : undefined,
        canalMarketing: formState.canalMarketing.wasTouched ? formState.canalMarketing.value as CanalMarketing : undefined,
        esTurista: formState.esTurista.wasTouched ? formState.esTurista.value : undefined,
        idPaisProveniencia: formState.paisProveniencia.wasTouched ? formState.paisProveniencia.value : undefined,
        idCiudadProveniencia: formState.ciudadProveniencia.wasTouched ? formState.ciudadProveniencia.value : undefined,
        fechaNacimiento: formState.fechaNacimiento.wasTouched ? formState.fechaNacimiento.value : undefined
    }

    await modificarPropietario(id, modificacion);
}